import { IMicroAppData, IMicroAppPlugin } from './types'

export abstract class BaseMicroAppPlugin {
  protected id: string
  protected name: string
  protected enabled: boolean

  constructor(id: string, name: string) {
    this.id = id
    this.name = name
    this.enabled = true
  }

  getId(): string {
    return this.id
  }

  getName(): string {
    return this.name
  }

  enable(): void {
    this.enabled = true
  }

  disable(): void {
    this.enabled = false
  }

  isEnabled(): boolean {
    return this.enabled
  }

  getStore?(): any
  initialize?(): void
  onMount?(data: any): void
  onUnmount?(data: any): void
}
